import { useCallback } from "react";
import CategoryBrowser from "@/components/feature/CategoryBrowser";
import { filterMovieList } from "@/utils/content";
import { movieGenres, movieSorts, regions, years } from "@/mocks/categories";
import type { ContentItem } from "@/types/content";

const groups = [
  { key: "region", label: "地区", options: regions },
  { key: "genre", label: "类型", options: movieGenres },
  { key: "year", label: "年份", options: years },
  { key: "sort", label: "排序方式", options: movieSorts.map((s) => s.label) },
];

const initialValues: Record<string, string> = {
  region: "全部地区",
  genre: "全部类型",
  year: "全部年份",
  sort: movieSorts[0].label,
};

export default function MoviePage() {
  const filter = useCallback((values: Record<string, string>): ContentItem[] => {
    const sort = movieSorts.find((s) => s.label === values.sort)?.key ?? "release";
    return filterMovieList({
      region: values.region,
      genre: values.genre,
      year: values.year,
      sort,
    });
  }, []);

  return (
    <CategoryBrowser
      heading="电影"
      crumbLabel="电影"
      description="影视工厂电影频道汇集最新上映与经典热门影片，支持按地区、类型、年份多维度筛选，并可按上映时间、评分、热度排序，帮你快速找到想看的好片。"
      groups={groups}
      initialValues={initialValues}
      filter={filter}
      emptyText="未找到符合条件的电影"
      pageSize={8}
    />
  );
}